module.exports = __webpack_public_path__ + "img/squire2.8b548449.png";